// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const UploadQueueProvider = ({ children }) => {
  // Framework
  const { uploadQueue } = usePortal();
  // Init
  useStackDependency(uploadQueue);
  // Render
  return <>{children}</>;
};

export { UploadQueueProvider };
